import { useState, useEffect } from 'react';
import i18n from '../i18n/config';
import Cookies from 'js-cookie';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = Cookies.get('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    // Set cookie with 1 year expiration
    Cookies.set('cookieConsent', 'true', { expires: 365 });
    setShowConsent(false);
  };

  const declineCookies = () => {
    // Set cookie with 1 year expiration
    Cookies.set('cookieConsent', 'false', { expires: 365 });
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-600">
            {i18n.t('cookie_consent.message')}{' '}
            <a 
              href={`/documents/${i18n.locale}/privacy_policy.pdf`}
              className="text-blue-600 hover:text-blue-800 ml-1 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18n.t('cookie_consent.privacy_policy')}
            </a>
          </p>
        </div>
        <div className="flex gap-4">
          <button
            onClick={declineCookies}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {i18n.t('cookie_consent.decline')}
          </button>
          <button
            onClick={acceptCookies}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {i18n.t('cookie_consent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 